const renderCheckboxSection = (
  heading,
  options,
  searchQuery,
  otherOptions,
  setOtherOptions,
  respectiveOption
) => {
  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleCheckboxChange = (e, setOptions, otherOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value)
    );
  };

  return (
    <div className="px-2">
      {filteredOptions.length > 0 && (
        <h2 className="text-lg font-semibold my-2">{heading}</h2>
      )}
      <ul className="flex flex-col flex-wrap">
        {filteredOptions.map((option) => (
          <li key={option}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                value={option}
                checked={
                  otherOptions.includes(option) ||
                  (respectiveOption && respectiveOption.includes(option))
                }
                onChange={(e) =>
                  handleCheckboxChange(e, setOtherOptions, options)
                }
              />
              {option}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

const CauseElement = ({
  itemFor,
  selectedCampaigns,
  selectedSuperCampaigns,
  selectedCountries,
  selectedImpactCategory,
  searchedObject,
  allData,
}) => {
  const { sortedCollectionData } = useSelector((state) => state.counter);

  const [itemData, setItemData] = useState([]);
  const [localCampaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (itemFor === "userPage") {
      setItemData(Feature_collections_data.slice(0, 4));
      // console.log(itemData);
    } else {
      setItemData(sortedCollectionData);
    }
  }, [sortedCollectionData, itemFor]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //const response = await fetch("https://api.impactoverse.com/api/app/all-campaigns");
        const data = allData;

        if (data) {
          // Filter the data based on selected options
          const filteredCampaigns = data.causeList.filter((campaign) => {
            return (
              !selectedCampaigns ||
              selectedCampaigns.includes(campaign.name) ||
              !selectedCountries ||
              selectedCountries.includes(campaign.country) ||
              !selectedImpactCategory ||
              selectedImpactCategory.includes(campaign.category) ||
              searchedObject.label === campaign.name ||
              (searchedObject.heading === "Countries" &&
                searchedObject.label === campaign.country) ||
              (searchedObject.heading === "Impact Categories" &&
                searchedObject.label === campaign.category)
            );
          });
          console.log(
            "selected searched ",
            searchedObject.label,
            searchedObject.heading
          );
          console.log(filteredCampaigns);

          // setCampaigns(filteredCampaigns);
          let tempArray = [];
          {
            const newObj = {
              count: data?.count || {},
              campaigns:
                filteredCampaigns.length > 0
                  ? filteredCampaigns
                  : data.causeList,
            };
            tempArray.push(newObj);
          }
          // console.log("This is new Obj", newObj.count);
          setCampaigns(tempArray);
        } else {
          console.error("API request failed:", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [
    selectedCampaigns,
    selectedSuperCampaigns,
    selectedCountries,
    selectedImpactCategory,
    searchedObject,
  ]);

  return (
    <>
      {localCampaigns.map((item) => {
        const { campaigns } = item;
        // console.log("Campaign Id", campaigns);

        return campaigns.map((campaignItem, campaignIndex) => {
          const {} = campaignItem;
          // console.log("Campaign Item", campaignItem);
          const imageName = campaignItem.name;
          const campaignId = campaignItem._id;
          const imageUrl = baseURL + campaignItem.logoUrl;
          console.log("This is the description", campaignItem.about);

          return (
            <article key={campaignId}>
              <div
                className="relative mb-12 rounded-2.5xl border border-jacarta-100 bg-white p-12 transition-shadow hover:shadow-xl dark:border-jacarta-700 dark:bg-jacarta-700 "
                key={campaignId}
              >
                <div className="text-center newseLatter-item" key={campaignId}>
                  <div
                    className={`mb-6 inline-flex rounded-full p-3`}
                    style={{ backgroundColor: "#beaaf7" }}
                  >
                    <div
                      className={` items-center justify-center rounded-full`}
                    >
                      <img
                        src={`${imageUrl}`}
                        alt={`${campaignItem.name} Logo`}
                        className="rounded-full h-16 w-16 object-fill"
                      />
                      {/* <Image
                        src={`${imageUrl}`} // Replace with the actual path to your dummy image
                        alt={`${campaignItem.name} Logo`}
                        // width={200}
                        // height={200} 
                        className="rounded-full"
                      /> */}
                    </div>
                  </div>
                </div>
                <span className="mb-2 inline-block text-2xs font-medium text-accent ">
                  {truncateText(campaignItem.category, 3)}
                </span>
                <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white line-clamp-1">
                  {imageName}
                </h3>
                <p className="dark:text-jacarta-300 line-clamp-2">
                  {campaignItem.about}
                </p>
                <Link href={`causes/${campaignItem._id}`}>
                  <button className="hover:bg-accent-dark font-display bg-accent rounded-full px-6 py-2 mt-4 text-sm text-white">
                    Campaigns
                  </button>
                </Link>
                <Link href={`causes/${campaignItem._id}`}>
                  <div className="absolute -bottom-6 left-1/2 inline-flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full bg-light-base dark:bg-jacarta-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      className="fill-accent dark:fill-accent-lighter"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"></path>
                    </svg>
                  </div>
                </Link>
              </div>
            </article>
          );
        });
      })}
    </>
  );
};

import React, { useState, useRef, useEffect } from "react";

import { HeadLine } from "../../components/component";

import Explore_collection_item from "../../components/collectrions/explore_collection_item";
import Meta from "../../components/Meta";
import Image from "next/image";
import {
  CampaignSvg,
  CauseSvg,
  CountrySvg,
  ImpactCategorySvg,
  SuperCampaignSvg,
} from "../../components/svg/svgFilesGlobal";
import { useSelector } from "react-redux";
import Link from "next/link";
import { truncateText } from "../../utils/functions";
import Browse_category_carousel from "../../components/carousel/Browse_category_carousel";
import Brand_campaign_carasoul from "../../components/brand/brand_campaigns";
export const baseURL = `${process.env.BASE_URL}/`;

const Explore_causes = () => {
  const inputRef = useRef(null);
  const campaignInputRef = useRef(null);
  const superCampaignInputRef = useRef(null);
  const impactCategoryInputRef = useRef(null);
  const countryInputRef = useRef(null);
  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        campaignInputRef.current &&
        !campaignInputRef.current.contains(e.target) &&
        superCampaignInputRef.current &&
        !superCampaignInputRef.current.contains(e.target) &&
        impactCategoryInputRef.current &&
        !impactCategoryInputRef.current.contains(e.target) &&
        countryInputRef.current &&
        !countryInputRef.current.contains(e.target)
      ) {
        setDropdownShow(false);
        setSuperCampaignDropdownShow(false);
        setcampaignDropdownShow(false);
        setImpactCategoryDropDownShow(false);
        setCountryDropDownShow(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleInputFocus = () => {
    setDropdownShow(true);
    setSuperCampaignDropdownShow(false);
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setCountryDropDownShow(false);
  };
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [superCampaignOptions, setSuperCampaignOptions] = useState([]);
  const [impactCategoryOptions, setImpactCategoryOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [campaignDropDownShow, setcampaignDropdownShow] = useState(false);
  const [superCampaignDropDownShow, setSuperCampaignDropdownShow] =
    useState(false);
  const [impactCategoryDropDownShow, setImpactCategoryDropDownShow] =
    useState(false);

  const [countryDropDownShow, setCountryDropDownShow] = useState(false);

  const handleSuperCampaignDropdown = () => {
    setcampaignDropdownShow(false);
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(!superCampaignDropDownShow);
  };
  const [selectedCampaignOptions, setSelectedCampaignOptions] = useState([]);
  const [selectedSuperCampaignOptions, setSelectedSuperCampaignOptions] =
    useState([]);
  const [selectedImpactCategoryOptions, setSelectedImpactCategoryOptions] =
    useState([]);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);
  const [searchedValue, setSearchedValue] = useState({});
  const [allData, setAllData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // https://api.impactoverse.com/api/app/active-causes?isFeatured=false%22
        const response = await fetch(
          "https://api.impactoverse.com/api/app/active-causes?isFeatured=false"
        );
        const data = await response.json();

        if (data.success) {
          setAllData(data);
          const uniqueCampaigns = [
            ...new Set(data.causeList.map((campaign) => campaign.name)),
          ].filter((campaign) => campaign && campaign.trim() !== ""); // Filter null or empty values
          setCampaignOptions(uniqueCampaigns);

          const uniqueImpactCategories = [
            ...new Set(data.causeList.map((campaign) => campaign.category)),
          ].filter((category) => category && category.trim() !== ""); // Filter null or empty values
          setImpactCategoryOptions(uniqueImpactCategories);

          const uniqueCountries = [
            ...new Set(data.causeList.map((campaign) => campaign.country)),
          ].filter((country) => country && country.trim() !== ""); // Filter null or empty values
          setCountryOptions(uniqueCountries);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handlecampaignDropdown = () => {
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setDropdownShow(false);

    setcampaignDropdownShow(!campaignDropDownShow);
  };
  const handleImpactCategoryDropdown = () => {
    setcampaignDropdownShow(false);
    setDropdownShow(false);

    setCountryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setImpactCategoryDropDownShow(!impactCategoryDropDownShow);
  };
  const handleCountryDropdown = () => {
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(false);
    setCountryDropDownShow(!countryDropDownShow);
  };
  const handleCheckboxChange = (e, setOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value)
    );
  };
  const handleRemoveOption = (option, setOptions) => {
    setOptions((prevOptions) =>
      prevOptions.filter((prevOption) => prevOption !== option)
    );
  };

  const [dropdownShow, setDropdownShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <>
      <Meta title="Explore Causes & NPOs || Impactoverse " />
      <section className="relative mt-24 lg:pb-48 pb-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full"
          />
        </picture>

        <div className="container">
          <HeadLine
            text="Explore Causes & NPOs"
            classes="font-display text-jacarta-700 py-16 text-center text-4xl font-medium dark:text-white"
          />

          {/* <!-- Filter --> */}

          {/* <!-- Grid --> */}
          <div className="mb-8 flex flex-wrap items-start justify-between">
            <div className="flex flex-wrap items-center justify-between">
              <div className="flex flex-wrap items-center">
                <div className="my-1 mr-2.5 relative" ref={campaignInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handlecampaignDropdown}
                  >
                    <CauseSvg />
                    <span>Cause & NPOs</span>
                  </button>
                  {/* Dropdown Menu */}
                  {campaignDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {campaignOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                value={option}
                                className="h-5 cursor-pointer w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                // checked={selectedCampaignOptions.includes(option)}
                                checked={
                                  selectedSuperCampaignOptions.includes(
                                    option
                                  ) || selectedCampaignOptions.includes(option)
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCampaignOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div
                  className="my-1 mr-2.5 relative"
                  ref={impactCategoryInputRef}
                >
                  <button
                    className="group  dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleImpactCategoryDropdown}
                  >
                    <ImpactCategorySvg />
                    <span>Impact Category</span>
                  </button>
                  {/* Dropdown Menu */}

                  {impactCategoryDropDownShow && (
                    <div className="dropdown-menu ml-2.5 dark:bg-jacarta-800 z-10 min-w-fit px-2 py-2 w-full  whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {impactCategoryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={selectedImpactCategoryOptions.includes(
                                  option
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedImpactCategoryOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="my-1 mr-2.5 relative" ref={countryInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleCountryDropdown}
                  >
                    <CountrySvg />
                    <span>Country</span>
                  </button>
                  {/* Dropdown Menu */}
                  {countryDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {countryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={selectedCountryOptions.includes(
                                  option
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCountryOptions
                                  )
                                }
                              />
                            </label>
                            {option}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="my-1 mr-2.5 relative " ref={inputRef}>
              <div
                className={`flex h-10 box-border flex-row relative rounded-lg ${
                  dropdownShow ? "border border-accent" : ""
                }`}
              >
                <input
                  onFocus={handleInputFocus}
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={`
      font-bold text-jacarta-700 rounded-lg placeholder-jacarta-500 w-full py-2 px-1 pl-10
      dark:bg-white/[.15] dark:text-white dark:placeholder-white
      focus:outline-none focus:border-accent focus:border-1 box-border
    `}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={20}
                  height={20}
                  className="fill-jacarta-500 h-5 w-5 dark:fill-white absolute left-3 top-1/2 transform -translate-y-1/2"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                </svg>
              </div>

              {dropdownShow && (
                <div className="dropdown-menu h-[300px] overflow-y-auto dark:bg-jacarta-800 px-2 py-2 min-w-fit w-full ml-2.5 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full whitespace-break-spaces z-10 ">
                  {renderCheckboxSection(
                    "Causes & NPOs",
                    campaignOptions,
                    searchQuery,
                    selectedCampaignOptions,
                    setSelectedCampaignOptions,
                    selectedSuperCampaignOptions
                  )}
                  {renderCheckboxSection(
                    "Super Campaigns",
                    superCampaignOptions,
                    searchQuery,
                    selectedSuperCampaignOptions,
                    setSelectedSuperCampaignOptions,
                    selectedCampaignOptions
                  )}
                  {renderCheckboxSection(
                    "Impact Category",
                    impactCategoryOptions,
                    searchQuery,
                    selectedImpactCategoryOptions,
                    setSelectedImpactCategoryOptions
                  )}
                  {renderCheckboxSection(
                    "Countries",
                    countryOptions,
                    searchQuery,
                    selectedCountryOptions,
                    setSelectedCountryOptions
                  )}
                </div>
              )}
            </div>
            <div className="relative w-full mt-7 flex flex-row flex-wrap gap-2 ">
              {selectedCampaignOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Cause:</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCampaignOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedImpactCategoryOptions.map((option) => (
                <div
                  key={option}
                  className=" dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Impact Category :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(
                        option,
                        setSelectedImpactCategoryOptions
                      )
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedSuperCampaignOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Super Campaigns :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(
                        option,
                        setSelectedSuperCampaignOptions
                      )
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedCountryOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700 border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Country :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCountryOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-3">
            {allData && (
              <CauseElement
                itemFor="explore-collection"
                selectedCampaigns={selectedCampaignOptions}
                selectedSuperCampaigns={selectedSuperCampaignOptions}
                selectedCountries={selectedCountryOptions}
                selectedImpactCategory={selectedImpactCategoryOptions}
                searchedObject={searchedValue}
                allData={allData}
              />
            )}
          </div>
          {/* <div className="mb-0 lg:flex lg:flex-nowrap lg:space-x-8">
            <CauseElement
              itemFor="explore-collection"
              selectedCampaigns={selectedCampaignOptions}
              selectedSuperCampaigns={selectedSuperCampaignOptions}
              selectedCountries={selectedCountryOptions}
              selectedImpactCategory={selectedImpactCategoryOptions}
              searchedObject={searchedValue}
              allData={allData}
            />
          </div> */}
        </div>
      </section>
    </>
  );
};
export default Explore_causes;
